module.exports = __webpack_public_path__ + "img/wells-hydraulic.5f366d1f.svg";